import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import api, { num, money } from "@/lib/api";

export default function GlobalWorkforce() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/public/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  const cities = stats?.city_workforce || [];
  const max = Math.max(1, ...cities.map((c) => c.workers));

  return (
    <div>
      <section className="bg-[#0A1128] text-white">
        <div className="max-w-6xl mx-auto px-5 py-16">
          <h1 className="font-head text-4xl sm:text-5xl font-extrabold tracking-tight">The Global Workforce</h1>
          <p className="mt-4 text-lg text-slate-300 max-w-3xl">Aggregated, privacy-safe workforce activity across our operating hubs. Precise worker locations are never exposed publicly.</p>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6">
            <div><div className="font-mono-metric text-3xl font-bold text-[#1D4ED8]">{stats ? num(stats.total_workers) : "—"}</div><div className="text-xs uppercase tracking-widest text-slate-400 mt-1">Workers</div></div>
            <div><div className="font-mono-metric text-3xl font-bold text-[#1D4ED8]">{stats ? num(stats.cities) : "—"}</div><div className="text-xs uppercase tracking-widest text-slate-400 mt-1">Cities</div></div>
            <div><div className="font-mono-metric text-3xl font-bold text-[#1D4ED8]">{stats ? num(stats.countries) : "—"}</div><div className="text-xs uppercase tracking-widest text-slate-400 mt-1">Countries</div></div>
            <div><div className="font-mono-metric text-3xl font-bold text-[#1D4ED8]">{stats ? num(stats.leads) : "—"}</div><div className="text-xs uppercase tracking-widest text-slate-400 mt-1">Leads</div></div>
          </div>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-5 py-14">
        <h2 className="font-head text-2xl font-bold text-[#0A1128] mb-6">Workforce by city</h2>
        <div className="grid md:grid-cols-2 gap-4">
          {cities.map((c) => (
            <div key={c.name} data-testid={`gw-city-${c.name}`} className="p-5 rounded-2xl border border-slate-200 bg-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 font-semibold text-[#0A1128]"><MapPin size={16} className="text-[#1D4ED8]" /> {c.name}</div>
                <div className="font-mono-metric font-bold text-[#0A1128]">{num(c.workers)}</div>
              </div>
              <div className="mt-3 h-2 rounded-full bg-slate-100 overflow-hidden">
                <div className="h-full bg-[#1D4ED8] rounded-full" style={{ width: `${(c.workers / max) * 100}%` }} />
              </div>
            </div>
          ))}
          {cities.length === 0 && <p className="text-slate-500">No public workforce data yet.</p>}
        </div>
      </section>
    </div>
  );
}
